<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Artikal</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        readonly
                        v-model="article.article"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Šifra artikla</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Šifra artikla"
                        readonly
                        v-model="article.code"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Zahtjev poslao</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Zahtjev poslao"
                        v-model="article.requestedBy"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Email</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Email"
                        v-model="article.email"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Kontakt telefon</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Kontakt telefon"
                        v-model="article.phoneNumber"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Komentar korisnika</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Komentar korisnika"
                        v-model="article.comment"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center pb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Status</label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="article.status"
                      >
                        <option
                          :value="status.id"
                          :key="status.id"
                          v-for="status in statuses"
                        >
                          {{ status.title }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Interni komentar</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Interni komentar"
                        v-model="article.internalComment"
                      />
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'OutOfStockArticles' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteOutOfStockArticleRequest }}</strong>
        </h5>
        <div slot="body">
          <span v-html="articleModalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteOutOfStockArticleRequest"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>
<script>
import api from '@/services/api';
import { translations } from '@/mixins';
import Modal from "../shared/modal/Modal.vue";


export default {
  name: 'EditOutOfStockArticle',
  mixins: [translations],
  data() {
    return {
      statuses: [{
        id: 0,
        title: 'Nije procesuirano',
      }, {
        id: 1,
        title: 'Procesuirano',
      }],
    };
  },
  components: {
    Modal,
  },
  computed: {
    article() {
      return this.$store.getters.getOutOfStockArticle;
    },
    articleModalText() {
      return this.translations.areYouSureOutOfStockRequest.replace(
        "{article}",
        `<strong>${this.article.article}</strong>`
      );
    },
  },
  methods: {
    submitForm() {
      const { id, status, internalComment } = this.article;

      const payload = {
        articleOutOfStockRequestId: id,
        status,
        internalComment
      };

      api.updateOutOfStockArticle(payload).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'OutOfStockArticles' });
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    deleteOutOfStockArticleRequest() {
      api
        .deleteOutOfStockArticles([this.article.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: "OutOfStockArticles" });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: "OutOfStockArticles" });
        });
    },
  },
  mounted() {
    this.$store.dispatch('getOutOfStockArticle', parseInt(this.$route.params.id, 10));
  },
};
</script>
